import { createUseStyles } from 'react-jss';
export const useTabPanelsStyles = createUseStyles(() => ({
    tabPanels: {
        paddingTop: '1rem'
    }
}));
